import i18n from 'i18next';

import { User } from 'js/utils';
import Split from 'js/core_webpack/metrics/split.wjs';

export function localizationTest(testName: string): boolean {
  return (
    i18n.languages.includes('es') &&
    User.current != null &&
    Split.pickAndRecordSharedUserAbTest(
      User.current.id,
      'localize_frontend',
      testName,
      ['control', 'localize'],
    ) === 'localize'
  );
}

export function unrecordedLocalizationTest(): boolean {
  return (
    User.current != null &&
    Split.unrecordedAbTest(User.current.id, 'localize_frontend', [
      'control',
      'localize',
    ]) === 'localize'
  );
}
